import { render, staticRenderFns } from "./Authorize.vue?vue&type=template&id=dfe9c0c6&scoped=true&"
import script from "./Authorize.vue?vue&type=script&lang=js&"
export * from "./Authorize.vue?vue&type=script&lang=js&"
import style0 from "./Authorize.vue?vue&type=style&index=0&id=dfe9c0c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfe9c0c6",
  null
  
)

export default component.exports